$shm_hitalama_map_widget_contextmenu $mol_view
	widget $shm_hitalama_map_widget
	Map_page $shm_hitalama_map_page
	Contextmenu_common $mol_list
		sub <= contextmenu_common /
			<= Copy_id $shm_hitalama_map_widget_contextmenu_copy_id
				Map_page <= Map_page
				title \Скопировать id
				text <= ref_str \
			<= Open_props $mol_button_minor
				title \Параметры виджета
				click? <=> open_props? null
			^ open_in_editor_visible / <= Open_in_editor $mol_button_minor
				sub /
					<= Open_in_editor_icon $mol_icon_code_braces
					\Открыть в редакторе
				click? <=> open_in_editor? null
			<= To_front $mol_button_minor
				sub /
					<= Top_icon $mol_icon_arrow_collapse_up
					\На передний план
				click? <=> to_front? null
			<= To_back $mol_button_minor
				sub /
					<= Bottom_icon $mol_icon_arrow_collapse_down
					\На задний план
				click? <=> to_back? null
			- ^ grouping_view /
				<= Grouping $mol_button_minor
					title \Сгруппировать
					click? <=> grouping? null
				<= Ungrouping $mol_button_minor
					title \Разгруппировать
					click? <=> ungrouping? null
			<= Customize $mol_button_minor
				title \Кастомизация
				click? <=> customizer_add? null
			<= Make_extension $mol_button_minor
				title \Сделать chrome-расширением
				click? <=> make_extension? null
			<= Quick_access $mol_button_minor
				title <= quick_access_title \Добавить на панель быстрого доступа
				click? <=> quick_access_toggle? null

$shm_hitalama_map_widget_contextmenu_copy_id $mol_button_copy
	Map_page $shm_hitalama_map_page
